import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-manage-family-members',
  templateUrl: './manage-family-members.page.html',
  styleUrls: ['./manage-family-members.page.scss'],
})
export class ManageFamilyMembersPage implements OnInit {
  data: any = null;
  client_data: any;

  constructor(private modalController : ModalController) { }

  ngOnInit() {
  }

  async Close() {
    this.modalController.dismiss(null);
  }

}
